import React from "react";
import NavHome from "./home/NavHome";
import HeroSection from "./home/HeroSection";
import Service from "./home/ServiceSection";
import TraceSection from "./home/TraceSection";
import AboutSection from "./home/AboutSection";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./home.css";
import DataSection from "./home/DataSection";
import StakeholderSection from "./home/StakeholderSection";
import FaqSection from "./home/FaQSection";
import ContactUsSection from "./home/ContactSection";

const Home = () => {
  const nama = "Cassava Super";

  return (
    <div>
      <NavHome />
      <HeroSection />
      <Service />
      <TraceSection />
      <AboutSection />
      <DataSection />
      <StakeholderSection />
      <FaqSection />
      <ContactUsSection />

      <section id="footer-bottom">
        © Copyright <b>TELTI-PROJECT</b>
      </section>
    </div>
  );
};

export default Home;
